import request from '@/utils/request'
export function informationsAdd(arg) { //提交表单相关接口
  return request({
    url: '/api/nxin.nxapi.informations.add/1.0',
    method: 'get',
    params: arg
  })
}

export function selContentDetailByAdId(arg) {
  return request({
    url: '/api/nxin.information.content.get/2.0',
    method: 'get',
    params: arg
  })
}

export function selContentList(arg) {
  return request({
    url: '/api/nxin.information.content.list/2.0',
    method: 'get',
    params: arg
  })
}